import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const FeedbackIcon = ({
  width = "24",
  height = "24",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 14H9.05L14.05 9C14.2 8.85 14.3127 8.679 14.388 8.487C14.4633 8.295 14.5007 8.10767 14.5 7.925C14.4993 7.74233 14.4577 7.56333 14.375 7.388C14.2923 7.21267 14.184 7.05 14.05 6.9L13.15 5.95C13 5.8 12.8333 5.68767 12.65 5.613C12.4667 5.53833 12.275 5.50067 12.075 5.5C11.8917 5.5 11.7043 5.53767 11.513 5.613C11.3217 5.68833 11.1507 5.80067 11 5.95L6 10.95V14ZM7.5 12.5V11.55L10.025 9.025L10.525 9.475L10.975 9.975L8.45 12.5H7.5ZM10.525 9.475L10.975 9.975L10.025 9.025L10.525 9.475ZM11.175 14H18V12H13.175L11.175 14ZM2 22V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.0217 17.805 20.5507 18.0007 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
